'use client';

import {useEffect} from 'react';
import {useParams, useRouter, useSearchParams} from 'next/navigation';
import ScreenSwitch from 'c/components/screen-switch';
import {useStore} from 'c/store/store';

export default function CartLayout({children}: {children: React.ReactNode}) {
  const params = useParams();
  const router = useRouter();
  const searchParams = useSearchParams();

  const cartPath = useStore(state => state.cartPath);
  const setCartPath = useStore(state => state.setCartPath);

  const active =
    searchParams.get('active') || (!!params?.groupID ? 'group' : 'cart');

  useEffect(() => {
    // if (params?.groupID && params.groupID !== cartPath) {
    //   setCartPath(params.groupID.toString());
    // } else if (
    //   searchParams.get('active') &&
    //   searchParams.get('active') !== cartPath
    // ) {
    //   setCartPath(searchParams.get('active') || 'cart');
    // }
    if (active !== 'cart') {
      router.replace('/cart');
      setCartPath('cart');
    }
  }, [params, searchParams.get('active')]);

  return (
    <div className="mt-7 mb-10 w-full max-w-3xl md:mt-5">
      {/* <ScreenSwitch
        disabled={false}
        className='px-4'
        active={active}
        onSwitch={(x) => router.replace(`/cart?active=${x}`)}
        screens={[
          { id: 'cart', name: 'Cart' },
          { id: 'group', name: 'Shop Plus' },
        ]}
      /> */}
      <h4 className="text-center text-lg font-medium">Cart</h4>
      {children}
    </div>
  );
}
